import {Message,Button,Form,FormItem,Input,Container,Header,Aside,Card, Loading,Menu,MenuItem, Submenu,Main, MenuItemGroup, Footer, Breadcrumb, Row,Col,Select, DatePicker, Upload,Option, Dialog, BreadcrumbItem, Table, TableColumn, Switch, Radio, RadioGroup, Divider, Tooltip,MessageBox, Checkbox, CheckboxGroup
,Image,Pagination,Progress,Carousel,CarouselItem
} from 'element-ui'
import Vue from 'vue'
Vue.prototype.$message = Message
Vue.prototype.$confirm=MessageBox.confirm
Vue.use(Button)
Vue.use(Form)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Card)
Vue.use(FormItem)
Vue.use(Loading)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Main)
Vue.use(MenuItemGroup)
Vue.use(Footer)
Vue.use(Breadcrumb)
Vue.use(Row)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Option)
Vue.use(Select)
Vue.use(Dialog)
Vue.use(BreadcrumbItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Divider)
Vue.use(Tooltip)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Image)
Vue.use(Pagination)
Vue.use(Progress)
Vue.use(Carousel)
Vue.use(CarouselItem)


// WEBPACK FOOTER //
// ./src/components/work/until/ElementUiUntil.js